export enum AppDomain {
  LENDI_PL = 'lendi.pl',
  NESTO_RO = 'finance.imobiliare.ro',
}
